<template>
  <div class="main">
    <div class="main_top">
        <div class="main_top_title">已打印</div>
        <el-button  :size="size" v-if="showButton('search')" @click="$emit('update:showPrint', false)">返回</el-button>
    </div>
    <div class="main_header">
      <!-- <div class="header_item">
        <span class="header_label">项目名称：</span>
        <el-select v-model="search.proId" placeholder="请选择项目名称" clearable filterable @change="changeProjects">
            <el-option
            v-for="item in optionsProject"
            :key="item.proId"
            :label="item.proName"
            :value="item.proId">
            </el-option>
        </el-select>
      </div> -->
    </div>
    <div class="main_content" style="overflow:auto">
      <div class="main_items" v-for="(item,index) in dataList" :key="index">
        <div class="main_item_header">
            <div class="main_item_title">项目名称：</div>
            <div class="main_item_datas">{{item.proName}}</div>
            <el-button class="table_btn" style="margin-right:15px" size="mini" v-if="showButton('print')" @click="printProp(item)">打印</el-button>
        </div>
        <div class="main_item_contents">
            <div class="main_item_left">
              <div style="width:180px;height:180px">
                <!-- <img src="../../../assets/e.jpg" style="width:100%;height:100%"> -->
                <img :src="`${baseUrl}${userConfig === 'dev' ? '' : '/htapi'}/materials/steelPrint/test?num=${item.produceNumber}&type=4&steelProduceId=${item.steelProduceId}`" style="width:100%;height:100%">
              </div>
              <div class="main_item_idnumber">{{item.produceNumber}}</div>
            </div>
            <div class="main_line"></div>
            <div class="main_item_right">
                <div class="main_item_right_rows">
                    <div class="main_item_rhom"></div>
                    <div class="main_item_name">尺寸：</div>
                    <div class="main_item_info">{{item.sizeName}}</div>
                </div>
                <div class="main_item_right_rows">
                    <div class="main_item_rhom"></div>
                    <div class="main_item_name">配筋：</div>
                    <div class="main_item_info">{{item.reinforcementName}}</div>
                </div>
                <div class="main_item_right_rows">
                    <div class="main_item_rhom"></div>
                    <div class="main_item_name">块号：</div>
                    <div class="main_item_info">{{item.blockName}}</div>
                </div>
                <div class="main_item_right_rows">
                    <div class="main_item_rhom"></div>
                    <div class="main_item_name">制作人：</div>
                    <div class="main_item_info">{{item.platUserName}}</div>
                </div>
                <div class="main_item_right_rows">
                    <div class="main_item_rhom"></div>
                    <div class="main_item_name">班组：</div>
                    <div class="main_item_info">{{item.groupName}}</div>
                </div>
                <div class="main_item_right_rows">
                    <div class="main_item_rhom"></div>
                    <div class="main_item_name">打印时间：</div>
                    <div class="main_item_info">{{item.printTime}}</div>
                </div>
            </div>
        </div>
      </div>
    </div>
    <div class="main_footer">
      <el-pagination
        background
        @current-change="changePageNum"
        @size-change="changePageSize"
        :current-page="pageNum"
        :page-sizes="[9, 18, 45, 90]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { buttonPinia } from '../../../pinia/index';
import { changeSize} from '../../../plugins/public'; // 导入节流、动态切换组件尺寸方法
  export default {
    name: 'ReinPrint',
    props:{
        showPrint: {
            type: Boolean
        },
        rowsData:{
            type:Object
        }
    },
    data() {
      return {
        size: changeSize(), // 组件尺寸
        pageNum: 1,
        pageSize: 9,
        search:{},//查询条件
        total: 0,
        loading: false,
        dataList: [], //打印信息
        optionsProject:[],//项目名称
        baseUrl: process.env.VUE_APP_BASE_URL,
        userConfig: process.env.VUE_APP_OUT_PUT_DIR
      }
    },
    watch: {
      asyncVisible(bol) {
        if(!bol) {
          this.ruleForm = {};
          this.$refs.ruleForm.resetFields();
        }
      }
    },
    mounted() {
      const that = this;
      // 根据窗口大小动态修改组件尺寸
      window.onresize = () => {
        that.size = changeSize();
      }
      // that.getAllProjects()
      that.searchButtonInfo(true)
    },
    methods: {
      //改变项目
      changeProjects(){
        this.searchButtonInfo(true)
      },
     //获得所有项目名称
     getAllProjects(){
        let obj = {
            pageNum: 1,
            pageSize: 100000000
        }
        this.$api.Engineer.searchProjects(obj).then(res=>{
            if(res.statusMsg === 'ok'){
                this.optionsProject = res.data.list
                this.search.proId = this.rowsData.proId
                this.searchButtonInfo(true);
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
     },
     //打印按钮
     printProp(item){
      this.gopPrints(item.produceNumber)
     },
     //执行去打印
      gopPrints(numbers){
          const link = document.createElement('a');
          link.id = `link`;
          link.href = `printpipe://5,${numbers}`
          link.click()
      },
      // 查询按钮列表信息
      searchButtonInfo(bol) {
        if(bol) {
          this.pageNum = 1;
        }
        let params = Object.assign({},{
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          proId:this.rowsData.proId,
          steelPrintId:this.rowsData.steelPrintId
        })
        this.loading = true;
          this.$api.Print.seeBearPrintLists(params).then((res) => {
            if(res.statusMsg === 'ok') {
                this.total = res.data.total;
                this.dataList = res.data.list;
                this.loading = false;
            }else{
              this.$message.warning(res.statusMsg)
            }
          })
      },
      // 判断按钮权限信息
      showButton(str) {
        const pinia = buttonPinia();
        return pinia.$state.buttonInfo.includes(str);
      },      
      // 切换页数
      changePageNum(page) {
        this.pageNum = page;
        this.searchButtonInfo();
      },
      // 切换每页条数
      changePageSize(size) {
        this.pageSize = size;
        this.searchButtonInfo();
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '../../../style/layout-main.scss';
.main_top{
    display: flex;
    justify-content: space-between;
    padding: 10px 0px 5px 25px;
    margin: 0px 20px;
    border-bottom: 1px solid #1B50AF;

    .main_top_title{
        color: #39B5FE;
        margin-top: 5px;
        font-size: 16px;
        position: relative;
        &::before{
            content: "";
            width: 2px;
            height: 15px;
            background-color: #39B5FE;
            position: absolute;
            top: 1px;
            left: -10px;
        }
    }
}
.main_content{
    width: calc(100% - 28px);
    display: flex;
    flex-wrap: wrap;

    .main_items{
        // width: 100%;
        // max-width: calc(100%/3 - 25px);
        width: 512px;
        height: 300px;
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;
        border-bottom-left-radius: 6px;
        border-bottom-right-radius: 6px;
        background-color: #031A46;
        margin: 30px 20px 5px 5px;
        box-shadow:0px 12px 5px 0px #0C4F79;

        .main_item_header{
            border-top-left-radius: 6px;
            border-top-right-radius: 6px;
            background-color: rgba(57,181,254,0.3);
            line-height: 40px;
            display: flex;
            align-items: center;

            .main_item_title{
                flex: none;
                width: 100px;
                text-align: center;
                font-size: 16px;
                color: #E1EAEE;
            }
            .main_item_datas{
                flex: 1;
                color: #ffffff;
                font-weight: 900;
                font-size: 16px;
            }
        }
        .main_item_contents{
            width: 100%;
            height: calc(100% - 29px);
            background-color: #031A46;
            border-bottom-left-radius: 4px;
            border-bottom-right-radius: 4px;
            display: flex;
            overflow: auto;

            .main_item_left{
                width: 260px;
                height: 100%;
                display: flex;
                justify-content: center;
                flex-direction: column;
                align-items: center;
                padding: 10px 0px 0px 10px;
                margin-right: 10px;

                .main_item_idnumber{
                    padding-top: 10px;
                    color: #fff;
                    letter-spacing: 3px;
                    font-size: 15px;
                }
            }

            .main_line{
                width: 2px;
                height: 84%;
                margin-top: 24px;
                background-color: #073E63;
            }

            .main_item_right{
                width: calc(100% - 80px);
                height: 95%;
                margin-left: 10px;
                padding-top: 15px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                .main_item_right_rows{
                    display: flex;
                    // justify-content: center;
                    height: 35px;
                    position: relative;

                    .main_item_rhom{
                       width: 10px;
                       height: 10px;
                       background-color: #39B5FE; 
                       transform: roate(45deg);
                       -ms-transform:rotate(45deg);
                       -moz-transform:rotate(45deg); 
                        -webkit-transform:rotate(45deg);
                        -o-transform:rotate(45deg);
                        position: absolute;
                        top: 15px;
                        left: 15px;
                    }
                    .main_item_name{
                        width: 80px;
                        color: #B8BECB;
                        position: absolute;
                        flex: none;
                        left: 42px;
                        font-size: 16px;
                        top: 12px;
                    }
                    .main_item_info{
                        width: 100%;
                        flex: none;
                        color: #39B5FE;
                        position: absolute;
                        left: 120px;
                        font-size: 16px;
                        top: 11px;
                    }
                }
            }
        }
    }
}
//滚动条样式
::-webkit-scrollbar {
    width: 4px; 
    height: 3px;   
}
::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 5px #13497E;
    background: transparent;
}
::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px transparent;
    border-radius: 0;
    background: transparent;
}
</style>
